import React, { useMemo } from 'react';
import PrematchContext from '../../contexts/PrematchContext';
import { useFetchSeoSettings } from '../../data/fetchSeoSettings';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { getConfiguration } from '../../data/utils';
import PrematchTournament from './PrematchTournament';
import TournamentHeader from './TournamentHeader';

function PrematchTournamentsList(props) {
    const cfgSeo = getConfiguration().seo;
    const prematchContext = React.useContext(PrematchContext);
    const seoContext = React.useContext(SeoContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,false,cfgSeo);

    useHandleSeoSettings(seoSettingsState);

    const items = useMemo(() => {
        const tournaments = props.selectedTournaments.map(id => props.data.tournamentByUniqueId[id]);
        return tournaments.map(t => {
            const toggled = prematchContext.openCollapsed != null && prematchContext.openCollapsed ? false : true;
            return <PrematchTournament key={t.id}
                                       header={TournamentHeader}
                                       data={props.data}
                                       tournament={t}
                                       toggled={toggled}
                                       forceReload={props.forceReload}
                                       openFromPath={props.openFromPath} />;
        });
    }, [props.selectedTournaments, props.forceReload]);

    return (
        <>
            <SeoMetaTags />
            {items}
            <SeoMainContainer />
        </>
    );
}

export default PrematchTournamentsList;